import { Buffer } from 'buffer';

export const getBase64ImageFromURL = async (url: string) => {
  const fetchImageUrl = await fetch(url);
  const responseArrBuffer = await fetchImageUrl.arrayBuffer();
  const toBase64 = `data:${
    fetchImageUrl.headers.get('Content-Type') || 'image/png'
  };base64,${Buffer.from(responseArrBuffer).toString('base64')}`;

  return toBase64;
};
